import { Auth } from 'aws-amplify'
import { useContext, useMemo } from 'react'
import {
  AuthActionsContext,
  AuthContext,
} from 'src/providers/AuthProvider'

const useAuth = () => {
  const { isLoading, error, user } = useContext(AuthContext)
  const { login, logout } = useContext(AuthActionsContext)

  const isAdmin = useMemo(
    () => user?.accountType === 'ADMIN',
    [user?.accountType],
  )

  const isLoggedIn = useMemo(
    () => !isLoading && !!user,
    [user, isLoading],
  )

  return {
    isLoggedIn,
    isLoading,
    user,
    error,
    isAdmin,
    login,
    logout,
    isValid: async () =>
      (await Auth.currentSession())?.isValid?.(),
  }
}

export default useAuth
